// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Alert__close {\n  border-radius: 4px;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  position: absolute;\n  top: 8px;\n  right: 4px;\n  text-align: center;\n  text-shadow: none;\n  transition: all 250ms ease-in-out;\n  background: transparent;\n  border: none;\n}\n.Alert__close-flex {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
